const PaymentType = Object.freeze({
  subscription: "Subscription",
  addon: "Add-on",
  order: "Order",
});

export default PaymentType;
